package de.emgress.baskets.core.http

import core.enums.EEnvironmentVariables
import core.enums.ESponsor
import de.emgress.baskets.core.extensions.getValue
import dtos.games.outgoing.GameInfoDTOOut
import dtos.sponsor.SponsorDTOOut
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import io.ktor.utils.io.core.*
import kotlinx.browser.window
import kotlinx.serialization.json.Json

class HttpClientJS {

    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    private val mClient = HttpClient(Js) {
        followRedirects = true
        install(ContentNegotiation) {
            json(Json {
                prettyPrint = true
                ignoreUnknownKeys = true
                isLenient = true
            })
        }
        defaultRequest {
            url {
                protocol = if(EEnvironmentVariables.PRODUCT_FLAVOR.getValue() == "LIVE") URLProtocol.HTTPS else URLProtocol.HTTP
                host = window.location.hostname //TODO: get by environment variable
                port = if(EEnvironmentVariables.PRODUCT_FLAVOR.getValue() =="LIVE") 443 else window.location.port.toIntOrNull() ?: 80
            }
        }
    }

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    suspend fun getSchedule(): List<GameInfoDTOOut> {
        mClient.use { client ->
            return kotlin.runCatching { client.get("/api/v4/games/schedule").body<List<GameInfoDTOOut>>() }.getOrElse { listOf() }
        }
    }

    suspend fun getPlayoffs(): List<GameInfoDTOOut> {
        mClient.use { client ->
            return kotlin.runCatching { client.get("/api/v4/games/playoffs").body<List<GameInfoDTOOut>>() }.getOrElse { listOf() }
        }
    }

    suspend fun getScheduleSponsor(): List<SponsorDTOOut> {
        mClient.use { client ->
            return kotlin.runCatching { client.get("/api/v4/sponsor/${ESponsor.WEBSITE.mName}").body<List<SponsorDTOOut>>() }.getOrElse { listOf() }
        }
    }

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}